import { clock, dolumAciklama, dolumEtiketi, price as fmtPrice, qty } from '../format'
import type { Fill } from '../types'

/**
 * `İşlemlerim` sekmesi — `Gerçekleşen İşlemlerim`, yani gölge dolumlarımız.
 *
 *     Yön │ Tarih │ Fiyat │ Hacim
 *
 * Emir açma ve açık emir yönetimi burada DEĞİL: ikisi de emir defteri
 * panelindeki `Emirlerim` sekmesinde (kullanıcı isteği). Emrin hayat döngüsü
 * orada, gerçekleşen sonuç burada.
 *
 * Başlık şeridi kayan alanın DIŞINDA: liste kaydırılırken sütun adları yerinde
 * kalmalı (aynı desen `Emirlerim` ve eşleşme listesinde de var).
 *
 * Başlığın sağında alış/satış AOF'u (kullanıcı isteği 2026-07-30): listedeki
 * satırların tek satırlık özeti — "ortalama kaça aldım, kaça sattım" bakışta
 * görünsün. PnL sayısı DEĞİL (dengesizlik, PTF/SMF, finansal etki girmez);
 * o hesap sunucuda, `PnL Takip` sayfasında. Burada ekrandaki dolumların
 * ağırlıklı ortalamasından başka bir şey yok — iki hesap yolu yarışmıyor.
 *
 * Kapalı kontratta da gösterilir — geçmiş işlemlerimiz kontrat kapansa da
 * bizim kaydımız.
 */

interface Props {
  contract: string | null
  fills: Fill[]
}

/** Bir yönün ağırlıklı ortalama fiyatı; o yönde dolum yoksa null.
 *
 * Miktarlar lot, fiyatlar TL/MWh — lot→MWh çarpanı (0,1) pay ve paydada
 * sadeleşir, sonuç yine TL/MWh. */
function aof(fills: Fill[], side: 'BUY' | 'SELL'): number | null {
  let tutar = 0
  let hacim = 0
  for (const f of fills) {
    if (f.side !== side) continue
    tutar += f.price * f.quantity
    hacim += f.quantity
  }
  return hacim > 0 ? tutar / hacim : null
}

export function FillsPanel({ contract, fills }: Props) {
  if (!contract) {
    return <div className="tab-empty">Bir kontrat seç.</div>
  }

  const alisAof = aof(fills, 'BUY')
  const satisAof = aof(fills, 'SELL')

  return (
    <div className="shadow-panel">
      <div className="shadow-section fills-title">
        <span>Gerçekleşen İşlemlerim ({fills.length})</span>
        <span className="fills-aof">
          <span
            className="yon-al"
            title="Alış dolumlarımın ağırlıklı ortalama fiyatı (TL/MWh)"
          >
            Alış {fmtPrice(alisAof)}
          </span>
          <span className="fills-aof-ayrac">/</span>
          <span
            className="yon-sat"
            title="Satış dolumlarımın ağırlıklı ortalama fiyatı (TL/MWh)"
          >
            Satış {fmtPrice(satisAof)}
          </span>
        </span>
      </div>

      <div className="fills-head">
        <span>Yön</span>
        <span>Tarih</span>
        <span className="num">Fiyat</span>
        <span className="num">Hacim</span>
        <span title="Dolumun kaynağı: Simüle / Süpürdük / Süpürüldük">Tip</span>
      </div>

      <div className="fills-body">
        {fills.length === 0 ? (
          <div className="shadow-empty">Henüz gerçekleşen işlem yok.</div>
        ) : (
          fills.map((fill) => (
            <div className="fills-row" key={`${fill.orderId}-${fill.tradeId}`}>
              <span
                className={fill.side === 'BUY' ? 'yon-al' : 'yon-sat'}
                title={fill.side === 'BUY' ? 'Alış' : 'Satış'}
              >
                {fill.side === 'BUY' ? '▲' : '▼'}
              </span>
              <span className="muted">{clock(fill.ts)}</span>
              {/* Dolum fiyatı KENDİ limitimiz; tetikleyen işlemin fiyatı tooltip'te.
                  İkisi karıştırılırsa gerçekte kapatılamayacak bir kâr yazılır. */}
              <span
                className="num"
                title={
                  `Emir ${fill.orderId} · tetikleyen gerçek işlem: ` +
                  `${fmtPrice(fill.tradePrice)}`
                }
              >
                {fmtPrice(fill.price)}
              </span>
              <span className="num">{qty(fill.quantity)}</span>
              <span
                className={`fill-tag ${fill.liquidity ?? 'trade'}`}
                title={dolumAciklama(fill.liquidity)}
              >
                {dolumEtiketi(fill.liquidity)}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  )
}
